import Vue from "vue";
import App from "./App.vue";
//import login from "./components/login.vue";
import router from "./router";
import "bootstrap/dist/css/bootstrap.min.css";
import "./css/bootstrap-datetimepicker.min.css";
import 'bootstrap-vue/dist/bootstrap-vue.css';
import "./css/fw/css/all.min.css";
import "./css/animate.css";
import "./sass/custom.scss";
import Vuelidate from "vuelidate"
import { BootstrapVue, IconsPlugin , SpinnerPlugin  } from 'bootstrap-vue'
import store from './store/index'
import * as VueGoogleMaps from 'vue2-google-maps'
import tafqeet from "./js/Tafqeet";



Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(SpinnerPlugin)
Vue.use(Vuelidate)
Vue.use(tafqeet)



Vue.config.productionTip = false;

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyDM5AuLt6zM3oz03QzM3VftGQuFRHuAUjM',
    libraries: 'places', // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)
 
    //// If you want to set the version, you can do so:
    // v: '3.26',
  },
 
  //// If you intend to programmatically custom event listener code
  //// (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
  //// instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
  //// you might need to turn this on.
  // autobindAllEvents: false,
 
  //// If you want to manually install components, e.g.
  //// import {GmapMarker} from 'vue2-google-maps/src/components/marker'
  //// Vue.component('GmapMarker', GmapMarker)
  //// then disable the following:
  // installComponents: true,
})
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
